export const mockUsers = [
  {
    name: '',
    role: '',
    _id: '',
    lastName: '',
    fullName: '',
    email: '',
    discipline: '',
    position: '',
    coreSkill: '',
    grade: '',
    DU: '',
    lastUpdate: ''
  }
]
